/**
 * Константы для текстовых элементов и редактора
 */
export const TEXT_ELEMENT_CONSTANTS = {
    DEFAULT_FONT_FAMILY: 'Nunito',
    DEFAULT_FONT_SIZE: 18,
    DEFAULT_ELEMENT_WIDTH: 200,
    DEFAULT_ELEMENT_HEIGHT: 50,
    TEXT_PADDING: 12, // 4px padding элемента + 8px padding textarea
    DEFAULT_STROKE_WIDTH: 2,
    // Базовая высота элемента для вычисления коэффициента масштабирования текста
    // При высоте элемента 1000px коэффициент = 1
    BASE_HEIGHT_FOR_TEXT_SCALE: 1000,
};
export const EDITOR_CONSTANTS = {
    TOOLBAR_HEIGHT: 40,
    BUTTONS_HEIGHT: 40,
    TOOLBAR_OFFSET: 2,
    BUTTONS_OFFSET: 10,
    TOOLBAR_PADDING: '5px 15px',
    TOOLBAR_BORDER_RADIUS: '8px',
    TOOLBAR_BACKGROUND_COLOR: 'transparent',
    TOOLBAR_Z_INDEX_BASE: 1001,
    TOOLBAR_Z_INDEX_TABLE: 1002,
};
/**
 * Доступные размеры шрифта
 */
export const FONT_SIZES = [10, 12, 14, 16, 18, 20, 24, 28, 32, 36];
/**
 * Палитра цветов для выбора цвета текста и фона
 */
export const COLOR_PALETTE = [
    '#000000',
    '#333333',
    '#666666',
    '#999999',
    '#CCCCCC',
    '#FFFFFF',
    '#FF0000',
    '#FF6600',
    '#FFCC00',
    '#00FF00',
    '#00CCFF',
    '#0066FF',
    '#0000FF',
    '#6600FF',
    '#CC00FF',
    '#FF00CC',
];
/**
 * Константы для позиционирования всплывающего тулбара
 */
export const FLOATING_TOOLBAR_CONSTANTS = {
    TOOLBAR_HEIGHT: 50,
    TOOLBAR_WIDTH: 400,
    OFFSET: 8,
    MIN_TOP: 10,
    MIN_LEFT_OFFSET: 10,
    UPDATE_DELAY: 100, // Задержка перед показом тулбара (мс)
};
